import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { twMerge } from 'tailwind-merge';

import type { CtaFields } from '@boss/types/corporate-jobs';
import { icons } from '@boss/ui';

import { getPagePathByEntry } from '../../utils/getPagePathByEntry';

const getHref = (entry: CtaFields, locale: string) => {
  const { internalLink, externalLink, anchor } = entry;

  if (!internalLink) {
    return externalLink ?? '';
  }

  const internalLinkPath = getPagePathByEntry(internalLink, locale);
  const anchorLink = anchor?.anchorLinkText ? `#${anchor.anchorLinkText}` : '';

  return `${internalLinkPath}${anchorLink}`;
};

const getButtonProps = (
  entry: CtaFields,
  locale: string,
  isInColored2ColumnsSection?: boolean,
  inline?: boolean,
  hasBackground?: boolean,
): {
  anchorClassName: string;
  className?: string;
  onDark?: boolean;
  fileToDownload?: string;
  href: string;
  icon: undefined | IconDefinition;
  iconPosition: 'left' | 'right';
  label: string;
  type: 'primary' | 'secondary' | 'tertiary' | 'link';
  hasBackground?: boolean;
} => {
  const { label, icon, ctaVariation, iconPosition, fileToDownload } = entry;
  const inlineClassName = inline ? 'inline-flex w-fit' : 'w-fit';
  const borderClassName = hasBackground && ctaVariation.toLowerCase() === 'secondary' ? 'border-white' : '';

  return {
    anchorClassName: 'w-fit',
    className: twMerge(inlineClassName, borderClassName),
    fileToDownload: fileToDownload?.file?.url,
    href: getHref(entry, locale),
    icon: icon && icons.getPreloadedIcon(icon),
    iconPosition: iconPosition === 'prefixed' ? 'left' : 'right',
    label,
    onDark: isInColored2ColumnsSection,
    type: ctaVariation.toLowerCase() as 'primary' | 'secondary' | 'tertiary' | 'link',
  };
};

export default getButtonProps;
